export const environment = {
  production: true,
  apiUrl: 'https://agroinformer.co'
};